import cn from 'classnames';
// Types
import { GetNotReviewedInterviewAnswerVideos_getNotReviewedInterviewAnswerVideos } from 'api/interview/types/GetNotReviewedInterviewAnswerVideos';
// Ui2
import Button from 'ui3/Button/Button';
// Styles
import styles from './InterviewAnswerVideoCard.module.scss';

type InterviewAnswerVideoCardProps = {
  index: number;
  answerVideo: GetNotReviewedInterviewAnswerVideos_getNotReviewedInterviewAnswerVideos;
  setReviewModalVisibility: (
    answerVideo: GetNotReviewedInterviewAnswerVideos_getNotReviewedInterviewAnswerVideos
  ) => void;
  compact?: boolean;
};

const InterviewAnswerVideoCard = ({
  index,
  answerVideo,
  compact = false,
  setReviewModalVisibility,
}: InterviewAnswerVideoCardProps) => {
  const { interviewQuestion } = answerVideo;
  const questionText = interviewQuestion?.questionText || 'Interview Answer';

  const handleReviewModalOpen = () => {
    setReviewModalVisibility(answerVideo);
  };

  return (
    <div className={cn(styles.root, { [styles.rootCompact]: compact })}>
      <div className={styles.infoWrapper}>
        <p className={cn(styles.title, styles.large)}>
          Interview Clip #{index}
        </p>

        <div className={styles.dataSection}>
          <p className={styles.data}>
            Question:<span className={styles.dataValue}>{questionText}</span>
          </p>
          {interviewQuestion?.topicName && (
            <p className={styles.data}>
              Topic:
              <span className={styles.dataValue}>
                {interviewQuestion.topicName}
              </span>
            </p>
          )}
        </div>

        <div className={styles.buttonWrapper}>
          <Button
            size="medium"
            variant="secondary"
            onClick={handleReviewModalOpen}
            className={styles.reviewMediaPostButton}
          >
            Review
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InterviewAnswerVideoCard;
